// 99吃瓜 站点内容数据（简体中文）

export interface GossipItem {
  time: string;
  level: "爆" | "热" | "温";
  category: string;
  title: string;
  summary: string;
  heat: number;
}

export const todayGossip: GossipItem[] = [
  {
    time: "14:22",
    level: "爆",
    category: "综艺",
    title: "《周末大舞台》决赛夜后台花絮流出，导演组连轴转细节被扒",
    summary:
      "有现场观众晒出多段后台短视频，剪辑组连续加班、临时改流程的画面引发讨论，不少人感慨综艺幕后远比台前精彩。",
    heat: 986,
  },
  {
    time: "13:48",
    level: "热",
    category: "明星",
    title: "网传某男团巡演加场在即，黄牛票已在二手平台悄悄炒热",
    summary:
      "多位票务博主放出“加场”信号，正价票与转票价差再度拉大，粉丝在超话里呼吁抵制溢价、理性购票。",
    heat: 874,
  },
  {
    time: "12:15",
    level: "温",
    category: "影视",
    title: "新剧《春分辞》路透照曝光，男女主同框氛围感拉满",
    summary:
      "片场侧拍流出后相关话题快速升温，服化道与取景被赞“细节在线”，剧方暂未就拍摄进度作出正式说明。",
    heat: 612,
  },
  {
    time: "11:05",
    level: "热",
    category: "社会",
    title: "“追星摆摊”生意走红，大学生兼职成主力军",
    summary:
      "在各大演出场馆周边，卖应援周边、帮忙代排的小生意越来越多，年轻人把这当成兼顾热爱与收入的副业。",
    heat: 733,
  },
  {
    time: "10:32",
    level: "爆",
    category: "综艺",
    title: "综艺疑似“剧本”争议升级，节目组深夜紧急回应",
    summary:
      "某真人秀被质疑环节设计痕迹过重，争议发酵数小时后节目组发声明，称“所有流程均真实录制、无干预编排”。",
    heat: 905,
  },
  {
    time: "09:47",
    level: "温",
    category: "网红",
    title: "千万粉探店博主“翻车”风波持续，合作品牌密集解约",
    summary:
      "因一段探店视频被质疑摆拍剪辑，该博主口碑急转直下，多个此前官宣合作的品牌已悄然删除相关宣传物料。",
    heat: 668,
  },
  {
    time: "08:20",
    level: "热",
    category: "明星",
    title: "资深女演员回归小荧屏，开机现场状态引广泛热议",
    summary:
      "阔别荧幕多年的实力派演员接下新剧本，开机路透中造型利落、状态在线，网友直呼“想看姐姐搞事业”。",
    heat: 540,
  },
];

export interface BreakingItem {
  id: number;
  tag: string;
  category: string;
  title: string;
  summary: string;
  date: string;
  heat: number;
  image: string;
}

export const breakingNews: BreakingItem[] = [
  {
    id: 1,
    tag: "独家跟进",
    category: "综艺",
    title: "《周末大舞台》录制风波持续发酵，导师名单为何反复横跳？",
    summary:
      "从网传拟邀到临时换人，短短一周内版本连换三次。多位知情人士透露，档期与档位只是表象，真正的博弈在镜头之外。",
    date: "09-06 14:22",
    heat: 2.8,
    image:
      "https://readdy.ai/api/search-image?query=Cinematic%20backstage%20of%20a%20grand%20variety%20show%20stage%2C%20warm%20crimson%20and%20amber%20spotlights%20cutting%20through%20soft%20haze%2C%20silhouetted%20crew%20monitors%20and%20camera%20booms%2C%20dark%20moody%20maroon%20background%20with%20bokeh%20lights%2C%20no%20visible%20faces%2C%20editorial%20magazine%20photography%2C%20stylized%20artistic%20atmosphere%2C%20dramatic%20high%20contrast&width=900&height=620&seq=breaking-01-2026&orientation=landscape",
  },
  {
    id: 2,
    tag: "最新爆料",
    category: "明星",
    title: "顶流男星被曝行程连轴转，团队凌晨回应“一切以官方为准”",
    summary:
      "商务、综艺、新剧三线并进的消息传出后，粉丝既心疼又担忧。其经纪团队清晨发出简短声明，呼吁大家关注作品本身。",
    date: "09-06 13:48",
    heat: 2.1,
    image:
      "https://readdy.ai/api/search-image?query=Moody%20editorial%20scene%20of%20a%20private%20airport%20lounge%20at%20night%2C%20a%20tall%20figure%20in%20dark%20coat%20seen%20from%20far%20behind%2C%20flanked%20by%20assistants%2C%20warm%20amber%20terminal%20lights%20and%20glass%20reflections%2C%20no%20visible%20face%2C%20cinematic%20bokeh%2C%20premium%20gossip%20news%20cover%2C%20stylized%20and%20dramatic&width=900&height=620&seq=breaking-02-2026&orientation=landscape",
  },
  {
    id: 3,
    tag: "独家跟进",
    category: "影视",
    title: "《春分辞》原声带疑似提前泄露？剧方回应已介入处理",
    summary:
      "一段疑似主题曲的片段在短视频平台疯传，音质粗糙却仍引发期待。剧方回应称正配合平台核查来源，暂不影响上线节奏。",
    date: "09-06 12:15",
    heat: 1.6,
    image:
      "https://readdy.ai/api/search-image?query=Elegant%20film%20set%20of%20a%20period%20costume%20drama%2C%20warm%20lantern%20glow%20and%20soft%20candlelight%20over%20traditional%20Chinese%20architecture%2C%20hanging%20silk%20fabric%20and%20ink%20painting%20props%2C%20golden%20amber%20and%20terracotta%20palette%2C%20no%20people%20in%20focus%2C%20cinematic%20moody%20lighting%2C%20editorial%20magazine%20style%2C%20high%20detail%20artistic%20atmosphere&width=900&height=620&seq=breaking-03-2026&orientation=landscape",
  },
  {
    id: 4,
    tag: "最新爆料",
    category: "网红",
    title: "头部探店主播深陷“剧本摆拍”质疑，合作品牌陆续发声",
    summary:
      "一段被指剪辑穿帮的探店片段掀起舆论，网友扒出多个同期视频存在相似镜头。多位合作品牌表示正在核实合作内容与报价流程。",
    date: "09-06 09:47",
    heat: 1.9,
    image:
      "https://readdy.ai/api/search-image?query=Modern%20food%20review%20studio%20set%20with%20warm%20overhead%20kitchen%20lights%2C%20steaming%20dishes%20on%20marble%20counter%2C%20tripod%20camera%20and%20softbox%20in%20blurred%20foreground%2C%20crimson%20and%20amber%20tone%2C%20no%20recognizable%20face%2C%20editorial%20cinematic%20photography%2C%20stylized%20dramatic%20lighting&width=900&height=620&seq=breaking-04-2026&orientation=landscape",
  },
  {
    id: 5,
    tag: "热辣观察",
    category: "社会",
    title: "演唱会经济持续回暖，跨城观演成为年轻人的新周末方式",
    summary:
      "订票平台数据显示，跨省观演订单占比明显上升，“边旅行边看演出”正从少数爱好变成主流选择，也带火了场馆周边文旅消费。",
    date: "09-05 19:30",
    heat: 2.4,
    image:
      "https://readdy.ai/api/search-image?query=Vast%20crowd%20at%20an%20outdoor%20evening%20concert%20seen%20from%20high%20above%2C%20thousands%20of%20phone%20flashlights%20glowing%20warm%20amber%2C%20stage%20beams%20in%20crimson%20cutting%20the%20dark%20sky%2C%20silhouettes%20only%20no%20faces%2C%20cinematic%20wide%20editorial%20shot%2C%20stylized%20premium%20entertainment%20photography&width=900&height=620&seq=breaking-05-2026&orientation=landscape",
  },
  {
    id: 6,
    tag: "独家跟进",
    category: "影视",
    title: "古装剧《长安不眠夜》传定档，预告片进入倒计时",
    summary:
      "主创先后发布“夜”字主题动态，被解读为官宣预热。该剧筹备已久、服化道投入颇大，能否接住热度成为平台与观众共同期待。",
    date: "09-05 16:10",
    heat: 1.3,
    image:
      "https://readdy.ai/api/search-image?query=Night%20scene%20of%20ancient%20Chinese%20capital%20city%20street%2C%20warm%20lanterns%20and%20red%20silk%20banners%20glowing%20in%20amber%2C%20misty%20rooftops%20under%20a%20deep%20maroon%20sky%2C%20no%20people%2C%20cinematic%20period%20drama%20mood%2C%20editorial%20magazine%20photography%2C%20stylized%20artistic%20warm%20tone%20high%20detail&width=900&height=620&seq=breaking-06-2026&orientation=landscape",
  },
];

export interface TopicItem {
  rank: number;
  title: string;
  category: string;
  heat: string;
  delta: "up" | "new" | "flat";
}

export const hotTopics: TopicItem[] = [
  { rank: 1, title: "决赛夜后台花絮持续刷屏", category: "综艺", heat: "986.2万", delta: "up" },
  { rank: 2, title: "男团巡演加场疑似官宣预热", category: "明星", heat: "874.5万", delta: "new" },
  { rank: 3, title: "真人秀“剧本”争议回应发酵", category: "综艺", heat: "763.1万", delta: "up" },
  { rank: 4, title: "探店博主翻车品牌密集解约", category: "网红", heat: "668.8万", delta: "new" },
  { rank: 5, title: "《春分辞》路透与主题曲双热搜", category: "影视", heat: "612.3万", delta: "flat" },
  { rank: 6, title: "跨城观演成为周末新流行", category: "社会", heat: "540.6万", delta: "up" },
  { rank: 7, title: "资深女演员回归小荧屏开机", category: "明星", heat: "498.2万", delta: "flat" },
  { rank: 8, title: "“追星摆摊”大学生副业走红", category: "社会", heat: "421.7万", delta: "up" },
  { rank: 9, title: "《长安不眠夜》预告倒计时", category: "影视", heat: "386.4万", delta: "new" },
  { rank: 10, title: "综艺幕后纪录片将上线", category: "综艺", heat: "302.9万", delta: "flat" },
];

export interface CategoryItem {
  name: string;
  desc: string;
  count: number;
  icon: string;
}

export const categoryList: CategoryItem[] = [
  { name: "明星动态", desc: "行程、营业、新作与争议一手速递", count: 1286, icon: "ri-star-smile-line" },
  { name: "影视综艺", desc: "定档、路透、录制内幕与口碑复盘", count: 932, icon: "ri-clapperboard-line" },
  { name: "社会热点", desc: "现象级话题背后的真实生活切面", count: 1140, icon: "ri-flashlight-line" },
  { name: "网红世界", desc: "头部博主起落与新面孔出圈记录", count: 754, icon: "ri-vidicon-line" },
  { name: "财经·饭圈", desc: "粉丝经济与娱乐产业账本解读", count: 486, icon: "ri-coins-line" },
  { name: "数码科技", desc: "虚拟偶像、AI 陪伴与内容新形态", count: 302, icon: "ri-cpu-line" },
];

export interface DeepItem {
  id: number;
  category: string;
  title: string;
  summary: string;
  author: string;
  readTime: string;
  date: string;
  image: string;
}

export const deepDives: DeepItem[] = [
  {
    id: 1,
    category: "深度长文",
    title: "“塌房”之后，粉丝经济为何仍在为情绪买单？",
    summary:
      "每当一位公众人物人设翻车，舆论总在讨论“粉丝到底图什么”。本文从组织化应援、圈层归属与情感投射三个角度，拆解偶像消费背后的心理账本——当热爱与理性相撞，买单的究竟是作品还是人设？",
    author: "编辑部·阿瓜",
    readTime: "约 8 分钟",
    date: "09-05",
    image:
      "https://readdy.ai/api/search-image?query=Abstract%20concept%20editorial%20of%20a%20broken%20porcelain%20mask%20floating%20above%20a%20crowd%20of%20glowing%20phone%20screens%2C%20warm%20crimson%20and%20amber%20light%2C%20dark%20moody%20background%2C%20symbolic%20and%20artistic%2C%20no%20faces%2C%20cinematic%20magazine%20photography%2C%20stylized%20premium%20feel&width=1200&height=680&seq=deep-01-2026&orientation=landscape",
  },
  {
    id: 2,
    category: "传播复盘",
    title: "从《春分辞》路透刷屏说起：一部热剧的流量密码",
    summary:
      "一张路透图如何在数小时内登上热搜？这篇复盘从选角舆情、服化道营销到“氛围感”文案拆解《春分辞》的传播链路，看看创作者与平台如何一起把“期待值”做成了一门精确的生意。",
    author: "观察员·小满",
    readTime: "约 6 分钟",
    date: "09-04",
    image:
      "https://readdy.ai/api/search-image?query=Close%20up%20editorial%20of%20elegant%20period%20costume%20fabric%20and%20hair%20ornaments%20on%20a%20dark%20wooden%20table%2C%20warm%20candlelight%20and%20amber%20glow%2C%20gold%20thread%20and%20jade%20details%2C%20no%20person%2C%20cinematic%20macro%20photography%2C%20stylized%20magazine%20cover%20atmosphere%2C%20rich%20terracotta%20tone%20high%20detail&width=1200&height=680&seq=deep-02-2026&orientation=landscape",
  },
  {
    id: 3,
    category: "产业观察",
    title: "黄牛票为何总抢不走：一场演唱会背后的暗战",
    summary:
      "从实名制到跨城开场，主办方、票务平台与黄牛之间的博弈从未停止。我们追踪了一场热门巡演的抢票全程，还原溢价链条的每一环，也试图回答：普通观众怎样才能真的“抢到票”。",
    author: "财经组·老周",
    readTime: "约 7 分钟",
    date: "09-03",
    image:
      "https://readdy.ai/api/search-image?query=Cinematic%20night%20shot%20of%20concert%20tickets%20and%20a%20smartphone%20with%20glowing%20countdown%20screen%20on%20a%20dark%20desk%2C%20warm%20amber%20stage%20bokeh%20in%20background%2C%20dramatic%20moody%20lighting%2C%20no%20faces%2C%20editorial%20premium%20photography%2C%20stylized%20and%20detailed&width=1200&height=680&seq=deep-03-2026&orientation=landscape",
  },
];

export interface FaqItem {
  question: string;
  answer: string;
}

export const faqList: FaqItem[] = [
  {
    question: "99吃瓜 的资讯来源可靠吗？",
    answer:
      "我们坚持信息聚合与独立求证并重。内容会优先标注来源性质（官方回应 / 多方信源 / 网传待证实），对尚未获得官方或可靠信源证实的信息一律以“网传”“据多位知情人士”等措辞明确提示，并在文末附上截至时间的核实状态，帮助大家判断可信度。",
  },
  {
    question: "看到瓜后会删稿吗？被误读怎么处理？",
    answer:
      "会的。任何一条资讯只要经核查与事实不符，或当事人通过正式渠道提出异议并提供依据，我们都会第一时间修正或下线，并在对应位置更新“勘误”。你也可以通过底部联系渠道向我们反馈线索，编辑部会逐条跟进。",
  },
  {
    question: "如何区分爆料与官方消息？",
    answer:
      "页面用醒目标签做了区分：“官方回应”“独家跟进”代表已多方核实的部分；“最新爆料”“网传”则提醒你该信息仍待进一步证实。吃瓜时请以当事人或机构的正式发声为准，谨慎站队，理性围观。",
  },
  {
    question: "我发现了新鲜瓜点，怎么投稿？",
    answer:
      "非常欢迎！进入页面底部“我要爆料”板块，填写事件类型、时间地点与简要经过即可。编辑部会核实素材与信源，在征得你同意的前提下再进行报道，并对可靠线索提供者严格保密。",
  },
  {
    question: "内容会搬运自媒体与短视频平台的爆料吗？",
    answer:
      "会综合参考，但不会简单复制。我们以“看得明白”为目标，把散落在各平台的信息重新核实、梳理成清晰的时间线与前因后果，力求让你点开一条就能看懂来龙去脉，而不是被碎片化信息绕晕。",
  },
  {
    question: "吃瓜会不会侵犯当事人权益？",
    answer:
      "这是我们的底线。本站在报道前会对涉及隐私、未成年人、无实证指控的内容做二次审核，坚决不传播未经证实的恶意揣测，不贴标签、不上升人身攻击，尊重每一位当事人的合法权益。",
  },
];